import React, { useCallback, useEffect, useState } from "react";
// FIXME: this endpoint does not work with the bearer token for some reason
import axios from "axios";
import _ from "lodash";
import EntityForm from "../CRUD/EntityForm/EntityForm";
import EntityList from "../CRUD/EntityList/EntityList";
import asBookingEngineEntity from "../CRUD/Common/BookingEngineEntityHOC";
import constants from "../CRUD/constants";
import { Alert } from "react-bootstrap-3";

import { withAuthorizationVerifier } from "../../../components/authorization-verifier";

import { useUserPropertyTickers } from "../../../components/user-tickers-providers";

import { FullWidthLoader } from "../../../components/full-width-loader";
import { defineMessages, FormattedMessage } from "react-intl";
import { Button } from "react-bootstrap";
import { useApiClient } from "../../../lib/http";
import { useKeycloakAuthz } from "../../../components/keycloak-provider";
import { getPropertyRpt } from "../../../lib/auth";

const BackButton = () => {
  return null;
};

const tableContainer = {
  marginTop: "20px",
};

export const messages = defineMessages({
  title: {
    id: "component.firstTimeReservationQueuer.title",
    description: "title",
    defaultMessage:
      "Reservation {reservationId} for {propertyTicker} has not been queued, click the button if you want to add it so it can be send to all channels of the property",
  },
  queue: {
    id: "component.firstTimeReservationQueuer.queue",
    description: "queue",
    defaultMessage: "Queue reservation",
  },
});

function FirstTimeReservationQueuer({ onReservationQueue, reservationId, propertyTicker }) {
  return (
    <div className="mb-8">
      <h3 className="mt-6">
        <FormattedMessage
          id="component.firstTimeReservationQueuer.title"
          values={{
            reservationId,
            propertyTicker,
          }}
        />
      </h3>
      <Button className="mt-2" variant="primary" type="button" onClick={onReservationQueue}>
        <FormattedMessage id="component.firstTimeReservationQueuer.queue" />
      </Button>
    </div>
  );
}

FirstTimeReservationQueuer.propTypes = {};

class ForwardingReservations extends React.Component {
  constructor(props, context) {
    super(props, context);
    props.config.fields.form.find(
      fieldForm =>
        fieldForm.fieldName === "hotelTicker" && (fieldForm.options = props.propertyTickers)
    );
    this.state = {
      entity: {},
      entityResult: false,
      hotelTicker: "",
      loading: false,
      showAlert: {},
      pendingReservations: [],
      reservationId: "",
      fields: props.config.fields,
      reservationHasNotBeenQueued: false,
    };
  }

  getFields = fields => {
    return fields && fields.form;
  };

  getStatusColor = status => {
    switch (status) {
      case "SUCCESS":
        return "#329911";
      case "PENDING":
        return "#ff9125";
      case "FAIL":
        return "#b20e0e";
      default:
        return "";
    }
  };

  showError = error => {
    const { response = {} } = error;

    if (response.status && response.status !== 200 && response.data) {
      const { data } = response;
      error = data.error;
    }
    this.setState({
      loading: false,
      showAlert: {
        type: "danger",
        message: error.toString(),
      },
    });
  };

  customEntityToListValuesMapper = ({ entities, currentLocale }) => {
    return entities.map(oldEntity => {
      const entity = { ...oldEntity };
      const color = this.getStatusColor(oldEntity.transactionStatus);
      oldEntity.transactionStatus = `<span style="color: ${color}">${oldEntity.transactionStatus}</span>`;

      return entity;
    });
  };

  fetchPendingReservations = async ({
    hotelTicker,
    reservationId,
    showAlert = this.state.showAlert,
  }) => {
    try {
      const { restConfig } = this.props.config;
      const { value: hotelTickerValue = "" } = hotelTicker;
      const url = `${restConfig.baseURL}/${restConfig.fetch.url({
        hotelTicker: hotelTickerValue,
        reservationId,
      })}`;
      const rpt = await this.props.cGetPropertyRpt(hotelTickerValue);
      // TODO: replace with httpclient
      const response = await axios.get(url, {
        headers: { authorization: `Bearer ${rpt}`, "x-property": hotelTickerValue },
      });

      if (response.status === 200) {
        const pendingReservations = response.data;
        const customActions = [
          {
            icon: ({ entity }) =>
              entity && entity.transactionStatus && entity.transactionStatus.includes("FAIL")
                ? "fa fa-refresh"
                : "fa fa-envelope",
            onExecute: ({ entity }) =>
              entity && entity.transactionStatus && entity.transactionStatus.includes("FAIL")
                ? this.handleForwardingReservations({ connectionId: entity.id, reset: true })
                : this.handleForwardingReservations({}),
          },
        ];
        this.setState({
          showAlert,
          pendingReservations,
          hotelTicker,
          reservationId,
          customActions,
          loading: false,
          reservationHasNotBeenQueued: Boolean(!pendingReservations.length),
        });
      }
    } catch (error) {
      console.log("Error", error);
      this.showError(error);
    }
  };

  handleSearch = async ({ formValues }) => {
    if (!formValues.hotelTicker || !formValues.reservationId) {
      return;
    }
    this.setState({
      loading: true,
      reservationHasNotBeenQueued: false,
    });
    this.fetchPendingReservations({ ...formValues, showAlert: {} });
  };

  handleForwardingReservations = async ({ connectionId, reset }) => {
    try {
      this.setState({
        loading: true,
      });
      const { restConfig } = this.props.config;
      const { hotelTicker, reservationId } = this.state;
      const { value: hotelTickerValue = "" } = hotelTicker;
      let showAlert = {};
      const url = `${restConfig.baseURL}/${reset ? restConfig.reset.url : restConfig.post.url}`;
      const params = {
        connectionId,
        hotelTicker: hotelTickerValue,
        reservationId,
        notificationType: "NOTIFY_RESERVES",
      };
      const rpt = await this.props.cGetPropertyRpt(hotelTickerValue);
      // TODO: replace with httpclient
      const response = await axios.post(url, params, {
        headers: { authorization: `Bearer ${rpt}`, "x-property": hotelTickerValue },
      });

      if (response.status === 200) {
        const { notifications } = response.data || {};

        if (notifications && notifications.length) {
          const { success, warning } = notifications[0];

          switch (success) {
            case 1:
              showAlert = {
                type: "success",
                message: "Forwarding reservation successful",
              };
              break;
            case 2:
              showAlert = {
                type: "warning",
                message: warning,
              };
              break;
            default:
          }
        }
      }
      this.fetchPendingReservations({ hotelTicker, reservationId, showAlert });
    } catch (error) {
      console.log("Error", error);
      this.showError(error);
    }
  };

  handleQueueReservation = async () => {
    try {
      let showAlert = {};
      this.setState({
        loading: true,
      });
      const { hotelTicker, reservationId } = this.state;
      const data = {
        reservationId,
        hotelTicker: hotelTicker.value,
        notificationType: "NOTIFY_RESERVES",
      };

      try {
        const rpt = await this.props.cGetPropertyRpt(hotelTicker.value);
        const response = await this.props.apiClient.post(
          "/api/properties/reservations/channels",
          data,
          {
            headers: {
              authorization: `Bearer ${rpt}`,
              "x-property": hotelTicker.value,
            },
          }
        );
        if (response.status === 200) {
          const { notifications } = response.data || {};

          if (notifications && notifications.length) {
            const { success, warning } = notifications[0];

            switch (success) {
              case 1:
                showAlert = {
                  type: "success",
                  message: "Forwarding reservation successful",
                };
                break;
              case 2:
                showAlert = {
                  type: "warning",
                  message: warning,
                };
                break;
              default:
            }
          }
        }
        await this.fetchPendingReservations({ hotelTicker, reservationId, showAlert });
      } catch (error) {
        console.log("Error", error);
        this.showError(error);
      }
    } catch (error) {
      console.log("Error", error);
      this.showError(error);
    }
  };

  render() {
    const {
      name,
      validation,
      renderers,
      translation,
      entityName,
      sorting,
      entities,
    } = this.props.config;
    const { fields } = this.state;
    const { getListPath = () => ({}), locales } = this.props;
    const {
      entity,
      entityResult,
      loading,
      pendingReservations,
      showAlert,
      customActions,
      reservationHasNotBeenQueued,
      hotelTicker,
      reservationId,
    } = this.state;
    console.debug("state", this.state);
    return (
      <div className={"wbkv9-form-ForwardingReservations"}>
        <EntityForm
          buttonMessage="search"
          loading={loading}
          name={name}
          entity={entity}
          entities={entities}
          validation={validation}
          renderers={renderers}
          fields={this.getFields(fields)}
          locales={locales}
          translation={translation}
          onSubmit={this.handleSearch}
          entityResult={entityResult}
          getListPath={getListPath}
          BackButton={BackButton}
          doesntShowSaveReminder={true}>
          <div style={tableContainer}>
            {!_.isEmpty(showAlert) && (
              <div>
                <Alert bsStyle={showAlert.type}>
                  <strong>{showAlert.message}</strong>
                </Alert>
              </div>
            )}
            {reservationHasNotBeenQueued ? (
              <FirstTimeReservationQueuer
                onReservationQueue={this.handleQueueReservation}
                propertyTicker={hotelTicker.value}
                reservationId={reservationId}
              />
            ) : (
              <EntityList
                customActions={customActions}
                loading={loading}
                entityName={entityName}
                entities={pendingReservations}
                validation={validation}
                renderers={renderers}
                nested={name}
                fields={fields}
                entityResult={entityResult}
                sorting={sorting}
                customEntityToListValuesMapper={this.customEntityToListValuesMapper}
                allowEdit={false}
                allowDelete={false}
                allowClone={false}
                allowCreate={false}
              />
            )}
          </div>
        </EntityForm>
      </div>
    );
  }
}

function ForwardingReservationsWrapper(props) {
  const userPropertyTickersList = useUserPropertyTickers();
  const apiClient = useApiClient({ usePropertyHeader: false });
  const [loading, setLoading] = useState(true);
  const keycloakAuthz = useKeycloakAuthz();
  const cGetPropertyRpt = useCallback(
    async propertyTicker => await getPropertyRpt(propertyTicker, keycloakAuthz),
    [keycloakAuthz]
  );
  useEffect(() => {
    setLoading(true);
    if (userPropertyTickersList.length) {
      setLoading(false);
    }
  }, [userPropertyTickersList]);

  if (loading) {
    return <FullWidthLoader />;
  }

  return (
    <ForwardingReservations
      {...props}
      apiClient={apiClient}
      cGetPropertyRpt={cGetPropertyRpt}
      propertyTickers={userPropertyTickersList}
    />
  );
}

ForwardingReservations.propTypes = {};

ForwardingReservations.defaultProps = {
  locales: ["es", "ca", "en", "fr", "it", "de"],
};

export default asBookingEngineEntity(withAuthorizationVerifier(ForwardingReservationsWrapper), {
  entityName: constants.ENTITY.FORWARDING_RESERVATIONS.name,
  type: "FORM",
});
